<template>
  <div>
    <h1>{{ section.header }}</h1>

    <p v-html="renderMarkdown(section.text)"></p>

    <v-card flat outlined class="ma-0 pa-4" v-if="section.checks">
      <p class="font-weight-bold">Kvittering att jag som handledare tagit del av instruktionerna ovan:</p>
      <div v-for="check in checks" :key="check.text">
        <v-checkbox hide-details class="marked-blue label-top" v-model="check.selected" :label="check.text" @change="checkChange" :disabled="isImitatingUser()"/>
      </div>
    </v-card>
    <ActionButton class="mt-4" actionIcon="$sl-arrow-right" :isDisabled="!allChecked || isImitatingUser()" @click="goNext"
      >Bekräfta</ActionButton
    >
    <ActionButton type="plain" depressed actionIcon="$sl-arrow-left" @click="$emit('previousStep')"
      >Föregående steg</ActionButton
    >
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import marked from 'marked'
import MessageBox from '@/components/Common/MessageBox'
import ActionButton from '@/components/Common/ActionButton'

export default {
  name: 'InstructionsSection',

  mixins: [],

  props: {
    section: {
      type: Object,
      default: {}
    }
  },

  data: () => ({
    allChecked: false
  }),

  components: {
    MessageBox,
    ActionButton
  },

  computed: {
    ...mapGetters('currentuser', ['isImitatingUser']),

    checks() {
      return this.section.checks.split('\n').reduce((acc, check) => {
        console.log('Checking check', check)
        if (check) {
          acc.push({
            text: check,
            selected: false
          })
        }

        return acc
      }, [])
    }
  },

  watch: {
    section: {
      handler: function () {
        this.allChecked = false
      }
    }
  },

  methods: {
    renderMarkdown(value) {
      return marked(value)
    },
    goNext() {
      this.$emit('nextStep')
    },
    checkChange() {
      if (this.checks.some(c => !c.selected)) {
        this.allChecked = false
      } else {
        this.allChecked = true
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
